/**
 * menuMobile.js
 * Tout ce qui concerne le menu principal lorsque nous somme dans la version mobile
 */

// Import
import './menuMobile.scss';
import $ from 'jquery';

/*var links = document.getElementsByTagName('a')
for(var i=0; i<links.length; i++) {
    var a = links[i]
    var href = a.href
    if (href.indexOf('://') > 0 && href.indexOf(location.protocol + '//' + location.host) !== 0) {
        a.classList.add("externe");
    }
}*/

$(document).ready(function () {

    if ($('h1').hasClass('mw-750px')){  
        //$('this').parent('article').addClass('mw-750px ');
       $('article').addClass('mw-750px');
    }
    
    $('.menuMobile_button-fermer').click(function (e) {
        e.preventDefault();
        $(this).removeClass('show');
        $(this).parent().removeClass('show');
        $(this).parent().parent().find('.menuTrigger').removeClass('show');
        $(this).parent().slideUp();
        return false;
    })
    
    $('#header-mobile .menuTrigger').click(function (e) {
        e.preventDefault();
        if ($(this).hasClass('show')) {
            $(this).removeClass('show');
            $(this).parent().removeClass('show');
            $(this).parent().find('.mobileMenu').removeClass('show');
        } else {
            var menuTriggers = document.getElementsByClassName("menuTrigger");
            for (var i = 0; i < menuTriggers.length; i++) {
                if(menuTriggers.item(i).classList.contains('show')){
                    menuTriggers.item(i).classList.remove('show');
                    menuTriggers.item(i).parentElement.classList.remove('show');
                    menuTriggers.item(i).parentElement.querySelectorAll('.mobileMenu')[0].classList.remove('show');
                }
            }
            $(this).addClass('show');
            $(this).parent().addClass('show');
            $(this).parent().find('.mobileMenu').addClass('show');
        }

        return false;
    })

});